import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import RoutesComponent from './routers/routesComponent.js';
import {BrowserRouter as Router} from 'react-router-dom'
import Footer from './components/footer.js';
import './resources/static/css/App.css';
import './resources/static/css/vendor-styles.css';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#050608',
    accent1Color: '#777576',
  }
});

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <MuiThemeProvider muiTheme={muiTheme}>
            <div className='admin-page-content'>
              <div className='header-data-content'>
                <RoutesComponent/>
              </div>
              <Footer/>
            </div>
          </MuiThemeProvider>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js